module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderConfirmation"
    }
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v("授業振替依頼をする")]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("以下の内容で授業振替依頼を行います")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("よろしければ「振替依頼をする」ボタンを押してください")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替を希望する授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [(_vm.receiverInfo.user_type === 'student') ? _c('lable', {
    key: "student-name"
  }, [_vm._v("\n            生徒のお名前：" + _vm._s(_vm.receiverInfo.fullname) + "様\n          ")]) : _vm._e(), _vm._v(" "), (_vm.receiverInfo.user_type === 'teacher') ? _c('label', {
    key: "teacher-name"
  }, [_vm._v("\n            先生のお名前：" + _vm._s(_vm.receiverInfo.fullname) + "先生\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付　　　　：" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.targetReservation.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間　　　　：" + _vm._s(_vm.reschedulingInfo.targetReservation.startTime.slice(0, -3)) + " 〜 " + _vm._s(_vm.reschedulingInfo.targetReservation.endTime.slice(0, -3)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替候補日時")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.reschedulingInfo.candidateDatetimes), function(candidate, index) {
    return _c('li', {
      key: 'candidate' + index
    }, [_c('div', {
      staticClass: "candidate-caption"
    }, [_c('i', {
      staticClass: "el-icon-caret-right"
    }), _vm._v(" "), _c('label', [_vm._v("候補" + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('div', [_c('label', [_vm._v("日付：" + _vm._s(_vm.formattedDate(candidate.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間：" + _vm._s(candidate.startTime) + " 〜 " + _vm._s(candidate.endTime))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(candidate.mode === 'slot' ? 'の1コマ' : 'の中で' + candidate.duration + '分間'))])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替希望理由")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, _vm._l((_vm.reschedulingInfo.reason.split('\n')), function(row) {
    return _c('div', {
      key: "reason-row"
    }, [_c('label', [_vm._v(_vm._s(row))])])
  }))]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? _c('div', {
    key: "reservation-option",
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替後の授業情報")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [_c('label', [_vm._v("授業の種類　　　　　　：" + _vm._s(_vm.reschedulingInfo.reservationOption.reservationType === '短期' ? '短期講座' : _vm.reschedulingInfo.reservationOption.reservationType + '授業'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("配布物（確認テスト等）：" + _vm._s(_vm.reschedulingInfo.reservationOption.hasTest ? 'あり' : 'なし'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("連絡事項：")]), _vm._v(" "), _vm._l((_vm.reschedulingInfo.reservationOption.reservationMessage.split('\n')), function(row) {
    return _c('div', {
      key: "message-row",
      staticClass: "message-row"
    }, [_c('label', [_vm._v(_vm._s(row))])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n      " + _vm._s(_vm.Message) + "\n    ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-cancel",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_vm._v("\n      戻って修正する\n    ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-ok",
    on: {
      "click": function($event) {
        _vm.okButtonClicked()
      }
    }
  }, [_vm._v("\n      振替依頼をする\n    ")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61f48e50", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f48e50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReschedulingPage/ReschedulingSenderConfirmation.vue
// module id = 727
// module chunks = 0